import React from "react";
import { Box, Button, Stack, Text } from "@mantine/core";
import { IconAlertTriangle } from "@tabler/icons-react";
import { RunError } from "./model/runErrors";
import styles from "./ReportCanvas.module.css";

export interface RunErrorPanelProps {
  error: RunError;
  onRetry: () => void;
}

/** Shown in place of the table when a run fails (e.g. 422 too many rows). */
export default function RunErrorPanel({ error, onRetry }: RunErrorPanelProps) {
  return (
    <Box className={styles.errorPanel} role="alert">
      <Stack gap="xs" align="center">
        <IconAlertTriangle size={22} className={styles.errorIcon} aria-hidden />
        <Text fw={600}>{error.title}</Text>
        <Text className={styles.errorText}>{error.message}</Text>
        {error.retryable && (
          <Button variant="default" size="xs" onClick={onRetry}>
            Try again
          </Button>
        )}
      </Stack>
    </Box>
  );
}
